export const COLORS = {
  blue: "#2878d7",
  green: "#188f4c",
  navy: "#10263d",
  orange: "#df7722",
  purple: "#6b35d7",
  red: "#d92d28",
  teal: "#0aa5b5",
};

export const STATUS_STYLES = {
  delai_depasse: {
    backgroundColor: "#fee7e7",
    color: "#c93632",
    label: "Délai dépassé",
  },
  done: {
    backgroundColor: "#d9f7e5",
    color: "#147a43",
    label: "Clôturée",
  },
  done_after_reopen: {
    backgroundColor: "#d9f7e5",
    color: "#147a43",
    label: "Clôturée après réouverture",
  },
  in_progress: {
    backgroundColor: "#fff0c2",
    color: "#995900",
    label: "En cours",
  },
  open: {
    backgroundColor: "#e4effc",
    color: "#175b9c",
    label: "Ouverte",
  },
  reopen: {
    backgroundColor: "#fce1e1",
    color: "#a92824",
    label: "Réouverte",
  },
};

export const PRIORITY_STYLES = {
  critique: {
    backgroundColor: "#fde2e2",
    color: "#ad2723",
    label: "Critique",
  },
  majeure: {
    backgroundColor: "#fff0c5",
    color: "#9a5b00",
    label: "Majeure",
  },
  mineure: {
    backgroundColor: "#d9f7e5",
    color: "#147a43",
    label: "Mineure",
  },
};

const border = "1px solid #cbd8e6";

const styles = {
  actionStatus: (status) => ({
    backgroundColor: status === "en_cours" ? "#fff0c2" : "#e4effc",
    color: status === "en_cours" ? "#995900" : "#175b9c",
    fontSize: 10.5,
    fontWeight: 800,
  }),
  actionsKpiGrid: {
    display: "grid",
    gap: 1.3,
    gridTemplateColumns: "minmax(0, 1fr) 1px minmax(0, 1fr)",
    height: "100%",
    minWidth: 0,
    "& > div": {
      minWidth: 0,
    },
  },
  actionsKpiHelper: {
    alignItems: "center",
    color: COLORS.orange,
    display: "flex",
    gap: 0.5,
    mt: 1,
    minWidth: 0,
    overflowWrap: "anywhere",
  },
  actionsKpiPaper: {
    border,
    borderRadius: "8px",
    backgroundColor: "#ffffff04",
    borderTop: `3px solid ${COLORS.orange}`,
    height: "100%",
    minWidth: 0,
    minHeight: 112,
    p: 1.8,
    width: "100%",
  },
  actionsKpiSeparator: { backgroundColor: "#dce4ed" },
  alert: { mb: 1.5 },
  badge: (config) => ({
    backgroundColor: config.backgroundColor,
    color: config.color,
    fontSize: 10.5,
    fontWeight: 800,
    height: 22,
    "& .MuiChip-icon": { color: "inherit", fontSize: 11 },
  }),
  chartCard: {
    border,
    borderRadius: "8px",
    minHeight: 230,
    p: 2,
  },
  chartCapture: { minWidth: 0 },
  chartHeader: { alignItems: "center", display: "flex", gap: 0.8 },
  chartIcon: { color: COLORS.teal, fontSize: 17 },
  chartsGrid: {
    display: "grid",
    gap: 1.5,
    gridTemplateColumns: { xs: "1fr", lg: "1fr 2fr" },
    mt: 1.5,
  },
  dashboard: {
    minHeight: "calc(100vh - 56px)",
    p: { xs: 1.5, sm: 2.5 },
  },
  dataGrid: {
    borderColor: "#cbd8e6",
    color: COLORS.navy,
    fontSize: 11.5,
    "& .MuiDataGrid-cell": { borderColor: "#d5e0eb" },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#173d61",
      color: "#fff",
      fontSize: 11,
      fontWeight: 800,
    },
    "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus": {
      outline: "2px solid #d4aa38",
      outlineOffset: -2,
    },
    "& .MuiDataGrid-columnSeparator, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton": {
      color: "#fff",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "#f6f9fc",
      cursor: "pointer",
    },
  },
  dataGridContainer: { height: 455, mt: 1.5, width: "100%" },
  dateFilter: {
    width: "100%",
    "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 12, height: 40 },
  },
  dialogGrid: { height: 560, minWidth: 900, width: "100%" },
  dialogTab: {
    color: "#52677c",
    fontSize: 12,
    fontWeight: 800,
    minHeight: 44,
    textTransform: "none",
  },
  dialogTabs: {
    borderTop: "1px solid #d5e0eb",
    px: 2,
    "& .MuiTabs-indicator": { backgroundColor: COLORS.teal, height: 3 },
    "& .Mui-selected": { color: `${COLORS.navy} !important` },
  },
  dialogTitle: { color: COLORS.navy, fontSize: 16, fontWeight: 800 },
  emptyChart: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
  },
  exportButton: {
    backgroundColor: COLORS.green,
    fontSize: 11,
    fontWeight: 700,
    minHeight: 38,
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": { backgroundColor: "#147a43" },
  },
  guideCard: {
    border,
    borderRadius: "10px",
    mt: 1.5,
    p: { xs: 1.5, sm: 2.5 },
  },
  guideHeader: {
    alignItems: "center",
    borderBottom: "1px solid #d5e0eb",
    display: "flex",
    gap: 1.2,
    pb: 1.5,
  },
  guideHeaderIcon: {
    alignItems: "center",
    backgroundColor: "#eef2ff",
    borderRadius: "9px",
    display: "flex",
    height: 36,
    justifyContent: "center",
    width: 36,
  },
  guideIcon: { color: COLORS.blue, fontSize: 19 },
  guideStep: (color) => ({
    alignItems: "center",
    backgroundColor: color,
    borderRadius: "8px",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 79,
    p: 1,
    textAlign: "center",
  }),
  guideStepGrid: {
    display: "grid",
    gap: 0.8,
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      md: "repeat(3, 1fr)",
      lg: "repeat(6, 1fr)",
    },
    mt: 1.6,
  },
  guideStepIcon: { color: "inherit", fontSize: 17 },
  guideStepNumber: { mt: 0.25 },
  guideStepTitle: { mt: 0.15 },
  helperIcon: { fontSize: 13 },
  filterAutocomplete: {
    // minWidth: { xs: "100%", sm: 420 },
    "& .MuiOutlinedInput-root": { borderRadius: "6px", fontSize: 12, minHeight: 40 },
  },
  filterBar: {
    alignItems: { md: "center" },
    border,
    borderRadius: "8px",
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    flexWrap: "wrap",
    gap: 1,
    mb: 1.5,
    p: 1.25,
  },
  kpiGrid: {
    display: "grid",
    gap: 1.25,
    gridTemplateColumns: {
      xs: "minmax(0, 1fr)",
      sm: "repeat(2, minmax(0, 1fr))",
      md: "repeat(3, minmax(0, 1fr))",
      lg: "repeat(6, minmax(0, 1fr))",
    },
  },
  kpiButton: {
    borderRadius: "8px",
    display: "block",
    height: "100%",
    minWidth: 0,
    textAlign: "left",
    width: "100%",
    "&:focus-visible": {
      outline: "3px solid #d4aa38",
      outlineOffset: "2px",
    },
    "&:hover .MuiPaper-root": {
      borderColor: "#91a9c0",
      boxShadow: "0 4px 12px rgba(16, 38, 61, 0.09)",
      transform: "translateY(-1px)",
    },
  },
  kpiHelper: (accent) => ({
    alignItems: "center",
    color: accent,
    display: "flex",
    gap: 0.5,
    mt: 1,
    minWidth: 0,
    overflowWrap: "anywhere",
  }),
  kpiLabel: { mt: 0.7, overflowWrap: "anywhere" },
  kpiPaper: (accent) => ({
    border,
    borderRadius: "8px",
    backgroundColor: "#ffffff04",
    borderTop: `3px solid ${accent}`,
    height: "100%",
    minWidth: 0,
    minHeight: 112,
    p: 1.8,
    transition: "border-color 150ms ease, box-shadow 150ms ease, transform 150ms ease",
    width: "100%",
  }),
  latestCard: {
    border,
    borderRadius: "8px",
    mt: 1.5,
    p: { xs: 1.25, sm: 2 },
  },
  latestHeader: {
    alignItems: "center",
    borderBottom: "1px solid #d5e0eb",
    display: "flex",
    gap: 1,
    pb: 1.2,
  },
  overdueAlert: { border: "1px solid #ffb8b5", mb: 1.5 },
  overdueDetails: { mt: 0.35 },
  overdueSkeleton: { mb: 1.5 },
  processChart: { height: 185, mt: 1 },
  referenceCell: { alignItems: "center", display: "flex", gap: 0.5 },
  skeleton: { p: { xs: 1.5, sm: 2.5 } },
  skeletonGrid: {
    display: "grid",
    gap: 1.25,
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2, 1fr)",
      xl: "repeat(6, 1fr)",
    },
    mt: 1.5,
  },
  skeletonSection: { mt: 1.5 },
  sectionError: { mt: 1.5 },
  statusChart: {
    alignItems: "center",
    display: "grid",
    gap: 1.5,
    gridTemplateColumns: { xs: "1fr", sm: "150px minmax(0, 1fr)" },
    minHeight: 170,
    mt: 1,
  },
  statusChartCenter: {
    left: "50%",
    position: "absolute",
    textAlign: "center",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
  statusChartFigure: {
    height: 140,
    justifySelf: "center",
    position: "relative",
    width: 150,
  },
  statusChartLegend: { minWidth: 0, width: "100%" },
  statusChartLegendCount: { ml: "auto" },
  statusChartLegendItem: {
    alignItems: "center",
    display: "flex",
    gap: 0.8,
    mb: 0.8,
  },
  statusChartLegendMarker: (color) => ({
    backgroundColor: color,
    borderRadius: "50%",
    height: 9,
    width: 9,
  }),
  statusPie: { pointerEvents: "none" },
  tableIcon: { color: COLORS.blue, fontSize: 20 },
  resetButton: {
    borderColor: "#9fb1c3",
    color: "#173d61",
    fontSize: 11,
    fontWeight: 700,
    minHeight: 38,
    textTransform: "none",
    width: { xs: "100%", md: "auto" },
    "&:hover": { backgroundColor: "#f3f7fa", borderColor: "#173d61" },
  },
  viewAllButton: { ml: "auto", textTransform: "none" },
  warningIcon: { color: COLORS.red, fontSize: 14 },
};

export default styles;
